<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :width="width"
    :before-close="close"
    :modal-append-to-body="true"
    append-to-body
  >
    <div>
      <el-scrollbar :native="false" class="tree-scroll-bar" style="                                                                                          height:500px;">
        <slot></slot>
      </el-scrollbar>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'description',
    provide() {
      return {
        description: this
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      visible: {
        type: Boolean,
        default: false
      },
      labelWidth: {
        type: String,
        default: '150px'
      },
      width: {
        type: String,
        default: '50%'
      }
    },
    data() {
      return {}
    },
    methods: {
      close() {
        this.$emit('close')
      }
    }
  }
</script>

<style>
  .tree-scroll-bar > .el-scrollbar__wrap {
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Description/description.vue